import { SubmitHandler, useForm } from "react-hook-form";

import { Button, Modal } from "@pentabd/ui";

import { InputTextVertical } from "@components";

import { useLanguage } from "@hooks/useLanguage";

import { updateETicketSettings } from "@api/e-tickets/ticket-settings";

import {
  TicketSettingsType,
  TicketCategorySettingsType,
} from "@type/tickets/ticket-settings";

import { STATUS } from "@constants/status.hrm";
import { URLS } from "@constants/urls";

const { TICKET_CATEGORIES } = URLS;
const { SUCCESS, FAILED } = STATUS;

interface UpdateModalType {
  isModalOpen: boolean;
  closeModal: () => void;
  modalData: TicketSettingsType;
  handleUpdateCategory: (arg: TicketCategorySettingsType) => void;
  setIsSuccessModalOpen: (arg: boolean) => void;
  setIsErrorModalOpen: (arg: boolean) => void;
  setIsUpdateModalOpen: (arg: boolean) => void;
}

export const UpdateModal = ({
  isModalOpen,
  closeModal,
  modalData,
  handleUpdateCategory,
  setIsSuccessModalOpen,
  setIsErrorModalOpen,
  setIsUpdateModalOpen,
}: UpdateModalType) => {
  const { language } = useLanguage();

  const methods = useForm<TicketSettingsType>({
    values: modalData,
  });

  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = methods;

  const onSubmit: SubmitHandler<TicketSettingsType> = (
    data: TicketSettingsType,
  ) => {
    updateETicketSettings(
      TICKET_CATEGORIES,
      modalData.id,
      {
        name: data.name,
      },
      (response) => {
        setIsErrorModalOpen(false);
        setIsUpdateModalOpen(false);
        if (response.status === SUCCESS) {
          reset();
          setIsSuccessModalOpen(true);
          handleUpdateCategory(response.data);
        } else if (response.status === FAILED) setIsErrorModalOpen(true);
      },
    );
  };

  return (
    <Modal
      isOpen={isModalOpen}
      overlay={isModalOpen}
      onClose={closeModal}
      closeAble
      portal
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="d-flex flex-column gap-8 px-10 py-9 border-bottom">
          <InputTextVertical
            label="TICKETS.SETTINGS.TAB.CATEGORY.FORM.INPUT.NAME"
            register={{
              ...register("name", { required: "Name is Required" }),
            }}
            error={errors}
            required
          />
        </div>
        <div className="p-9 d-flex justify-content-end align-items-center gap-6">
          <Button size="sm" fill="outline" type="light" onClick={closeModal}>
            {language === "en" ? "Cancel" : "বাতিল করুন"}
          </Button>
          <Button size="sm" fill="fill" type="primary" htmlType="submit">
            {language === "en" ? "Update" : "হালনাগাদ করুন"}
          </Button>
        </div>
      </form>
    </Modal>
  );
};
